import { api } from "@/services/api"
import type { CreateLifeUsagePayload } from "@/services/api/users/life-usage/create"
import { useMutation, useQueryClient } from "@tanstack/react-query"
import { useUser } from "../stores"
import mixpanelClient from "@/services/mixpanel"
import { differenceInDays, format } from "date-fns"

export function useRecordLifeUsage() {
  const queryClient = useQueryClient()
  const { lifeUsage, setLifeUsage, user } = useUser()

  return useMutation({
    mutationKey: ["record-life-usage"],
    mutationFn: (payload: CreateLifeUsagePayload) => api.user.lifeUsage.create(payload),
    onSuccess: (_, payload) => {
      const newLifeUsage = {
        activityCategory: payload.activityCategory as "FLASHCARD" | "CHALLENGE",
        createdAt: new Date().toISOString(),
        id: crypto.randomUUID().toString(),
        userId: user.id,
      }
      setLifeUsage([...lifeUsage.list, newLifeUsage])
      if ([...lifeUsage.list, newLifeUsage].length !== 5) return

      mixpanelClient.payments.livesUsed({
        email: user.email,
        features: lifeUsage.list.map((usage) => usage.activityCategory),
        registrationDate: format(user.createdAt, "dd-MM-yyyy"),
        daysBetween: differenceInDays(new Date(), user.createdAt),
        lastLifeUsage: lifeUsage.lastLifeUsage || "",
      })
    },
    onSettled: () => {
      queryClient.invalidateQueries({ queryKey: ["get-life-usage"] })
    },
  })
}
